import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { campaignData, tpriceData } from "../../store/action";
import SelectOpt from "../Multiselect/Multiselect";
import { useHistory } from "react-router-dom";

const OrderProductRow = ({ data }) => {
  const history = useHistory();

  return (
    <tr
      BGCOLOR="#f5f5f5"
      onClick={() => history.push(`/compaigndetail/${data.campaignId}`)}
      className="cp"
    >
      <td style={{ width: "20%" }}>
        <td style={{ paddingLeft: "10px" }}>
          <img src={data.designShirt} width={80} height={100} />
        </td>
        <td style={{ paddingLeft: "15px" }}>
          <p>
            <b>{data.shirtName}</b>
          </p>
        </td>
      </td>
      <td style={{ width: "15%" }}>
        <p
          style={{
            width: "70px",
            backgroundColor: data.colors,
            color: data.colors,
          }}
        >
          {data.colors}
        </p>
      </td>
      <td style={{ width: "16.6666666667%" }}>{data.size}</td>
      <td style={{ width: "16.6666666667%" }}>{data.quantity}</td>
      <td style={{ width: "16.6666666667%" }}>{data.price}€</td>
      <td style={{ width: "16.6666666667%" }}>
        {Number(data.price) * Number(data.quantity)}€
      </td>
    </tr>
  );
};
export default OrderProductRow;
